import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, inr } from "../lib/api";
import { Check, ArrowRight } from "lucide-react";
import useDocumentTitle from "../lib/useDocumentTitle";

const BADGE_LABEL = {
  "popular": "Most Popular",
  "recommended": "Recommended",
  "best-value": "Best Value",
  "new-launch": "New Launch",
  "limited-offer": "Limited Offer",
  "premium-choice": "Premium Choice",
};

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then(r => setServices(r.data)); }, []);
  useDocumentTitle("Packages & Pricing", "Compare Basic, Premium and Luxury house design packages — 2D construction drawings and 3D elevations starting at ₹8,500, delivered online across India.");

  return (
    <div className="bg-[#FEF3E2]/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#F7941D]">Services</span>
          <h1 className="font-display text-4xl lg:text-5xl font-extrabold text-[#1a3c5e] mt-2">Choose Your Package</h1>
          <p className="mt-3 text-gray-600">Compare and pick the perfect plan for your dream home.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {services.map(s => {
            // Resolve badge: prefer new `badge` field, fallback to legacy is_popular
            const badgeKey = s.badge || (s.is_popular ? "popular" : "");
            const badgeLabel = BADGE_LABEL[badgeKey] || "";
            const badgeColor = s.badge_color || "#F7941D";
            return (
              <Link key={s.slug} to={`/services/${s.slug}`} data-testid={`service-link-${s.slug}`}>
                <div className="bg-white rounded-2xl p-7 shadow-sm border border-[#1a3c5e]/10 hover-lift h-full">
                  <div className="flex items-baseline gap-2 mb-2 flex-wrap">
                    <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded bg-[#FEF3E2] text-[#F7941D]">{s.slug.toUpperCase()}</span>
                    {badgeLabel && (
                      <span className="text-[10px] font-bold uppercase px-2 py-1 rounded text-white whitespace-nowrap" style={{ backgroundColor: badgeColor }}>{badgeLabel}</span>
                    )}
                  </div>
                  <h2 className="font-display text-2xl font-bold text-[#1a3c5e]">{s.name}</h2>
                  <p className="text-sm text-gray-600 mt-1">{s.subtitle}</p>
                  <div className="flex items-baseline gap-2 mt-4">
                    <span className="font-display text-3xl font-extrabold text-[#F7941D]">{inr(s.price)}</span>
                    {s.original_price > s.price && <span className="text-sm text-gray-400 line-through">{inr(s.original_price)}</span>}
                  </div>
                  <div className="text-xs text-[#1a3c5e]/70 mt-4 mb-3">⏱ {s.delivery_text} · Revisions: {s.revisions}</div>
                  <ul className="space-y-1.5 mb-5">
                    {s.includes_list.slice(0,5).map((x, i) => (
                      <li key={i} className="text-sm text-gray-700 flex gap-2">
                        <Check className="w-4 h-4 text-emerald-600 mt-0.5 flex-shrink-0" /> <span>{x}</span>
                      </li>
                    ))}
                    {s.includes_list.length > 5 && <li className="text-xs text-[#F7941D] font-semibold">+ {s.includes_list.length - 5} more</li>}
                  </ul>
                  <div className="text-sm font-semibold text-[#F7941D] flex items-center gap-1">
                    View details <ArrowRight className="w-4 h-4" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
